(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template-bc-sf-filter-backup"]) return;
  try {
    
$(document).ready(function () {
  $('#read-more').click(function () {
    $('.collection-description').toggleClass('expanded');
    $(this).text($(this).text() == 'Read More +' ? 'Read Less -' : 'Read More +');
  });

  $('.collection-usp').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('.collection-usp').removeClass('active');
    $('.product-grid__container').removeClass('active');

    $(this).addClass('active');
    $("#" + tab_id).addClass('active');
  })

  $(function () {
    $('.product-card__item .product-meta__container').matchHeight();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template-boost-pfs-original"]) return;
  try {
    
$(document).ready(function () {
  $('#read-more').click(function () {
    $('.collection-description').toggleClass('expanded');
    $(this).text($(this).text() == 'Read More +' ? 'Read Less -' : 'Read More +');
  });

  $('.collection-usp').click(function () {
    var tab_id = $(this).attr('data-tab');

    $('.collection-usp').removeClass('active');
    $('.product-grid__container').removeClass('active');

    $(this).addClass('active');
    $("#" + tab_id).addClass('active');
  })

  $(function () {
    $('.product-card__item .product-meta__container').matchHeight();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    
  $(document).ready(function () {
    $('#read-more').click(function () {
      $('.collection-description').toggleClass('expanded');
      $(this).text($(this).text() == 'Read More +' ? 'Read Less -' : 'Read More +');
    });

  $('.collection-usp').on('click', function () {
      var colTab = $(this);
      var tab_id = $(this).attr('data-tab');

      $('.collection-usp.active').removeClass('active').find('.usp-title .change').text('Shop');
      $('.product-grid__container').removeClass('active');
      $('.changed').removeClass('changed').text('Shop');
      $(this).addClass('active');

     if ($(this).hasClass('active')) {
        $(this).find('.usp-title .change').addClass('changed').text('Now Shopping');

      } else {
        $('.collection-usp .usp-title .change').removeClass('changed');
      }

      $("#" + tab_id).addClass('active');
    })

    $(function () {
      $('.product-card__item .product-meta__container').matchHeight();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["frequent-questions"]) return;
  try {
    
$('.faq-header').click(function(e){
  $this = $(this).next('.faq-content');
  $this.slideToggle();
  $('.faq-content').not($this).slideUp();
  $('.expand-arrow', this).toggleClass('active');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
$(document).ready(function() {
  $('#primary-nav-bar').scrollToFixed();
  $('.xs-navbar__container').scrollToFixed({
    spacerClass: 'fixedSpacer',
  });
});

$('#xs-search-toggle').click(function() {
  $('.xs-search-toggle-container').slideToggle();
  if ($(".xs-nav-menu__container").css("display") == "block") {
    $(".xs-nav-menu__container").hide();
  }
});

$('.site-nav--has-submenu .site-nav__link').click(function(e) {
  $(this).next().slideToggle();
});

function stopBodyScrolling(bool) {
  var menuItem = document.getElementsByClassName('xs-nav-menu');
  document.body.addEventListener("touchmove", freezeVp, false);
  document.menuItem.addEventListener("touchmove", freezeVp, false);
  if (bool === true) {
    document.body.addEventListener("touchmove", freezeVp, false);
    document.menuItem.addEventListener("touchmove", freezeVp, false);
  } else {
    document.menuItem.addEventListener("touchmove", freezeVp, false);
    document.body.removeEventListener("touchmove", freezeVp, true);
  }
}
var freezeVp = function(e) {
  e.preventDefault();
};

$(".xs-menu-toggle").click(function() {
  $(".xs-nav-menu__container").slideToggle();
  if ($(".xs-nav-menu__container").css("display") == "block") {
    $(".xs-nav-menu__container").toggleClass("menu--opened");
    $('body').toggleClass('menu--opened');
  } else {
  };
  if ($(".xs-search-toggle-container").css("display") == "block") {
    $(".xs-search-toggle-container").hide();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
$('.hero-banner-arrow__container img').click(function(){
  var nextSection = $(this).parent('[id^=shopify-section-]').siblings().find('[id^=shopify-section-]');
        $("html, body").animate({
        scrollTop: ($(nextSection).offset().top)
    });
})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-template"]) return;
  try {
    
$(document).ready(function () {
  $('#read-more').click(function () {
    $('.collection-description').toggleClass('expanded');
    $(this).text($(this).text() == 'Read More +' ? 'Read Less -' : 'Read More +');
  });

$('.collection-usp').on('click', function () {
    var colTab = $(this);
    var tab_id = $(this).attr('data-tab');

    $('.collection-usp.active').removeClass('active').find('.usp-title .change').text('Shop');
    $('.product-grid__container').removeClass('active');
    $('.changed').removeClass('changed').text('Shop');
    $(this).addClass('active');

   if ($(this).hasClass('active')) {
      $(this).find('.usp-title .change').addClass('changed').text('Now Shopping');

    } else {
      $('.collection-usp .usp-title .change').removeClass('changed');
    }

    $("#" + tab_id).addClass('active');
  })

  $(function () {
    $('.product-card__item .product-meta__container').matchHeight();
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["visit-shop"]) return;
  try {
    
$(".directions_header").click(function(e) {
  $this = $(this).next(".directions_content");
  $(".directions_header").next(".directions_content").not($this).slideUp();
  $this.slideToggle();
  $(".expand-arrow", this).toggleClass("active");
});

  } catch(e) { console.error(e); }
})();
})();
